import React from 'react';
import { Link } from '@qred/components-library';
import useTranslate from './useTranslate';
import { LoanType } from '~/enums';
import useExternalLoanLinks from './useExternalLoanLinks';
import useTermsAndConditionsModal from './useTermsAndConditionsModal';
import { LoanGranter } from '~/types/types';

interface UseLoanConsentTextParams {
  loanType: LoanType;
  granter?: LoanGranter;
  applicationId?: string | number;
}

const useLoanConsentText = ({
  loanType,
  granter,
  applicationId,
}: UseLoanConsentTextParams) => {
  const t = useTranslate();
  const { openModal } = useTermsAndConditionsModal(granter, applicationId);
  const {
    shouldLinkExternalSite,
    openGeneralTerms,
    openProductTerms,
    openPriceList,
    productTermsLinkText,
  } = useExternalLoanLinks(loanType);

  let consentText;

  if (shouldLinkExternalSite) {
    const generalTermsLink = (
      <Link size="sm" onClick={openGeneralTerms}>
        {t('OnboardingOffer.TermsAndConditionslinkText')}
      </Link>
    );

    const productTermsLink = (
      <Link size="sm" onClick={openProductTerms}>
        {productTermsLinkText}
      </Link>
    );

    const priceListingLink = (
      <Link size="sm" onClick={openPriceList}>
        {t('OnboardingOffer.PriceListingLinkText')}
      </Link>
    );

    const formattedLinksText = (
      <>
        {generalTermsLink}, {productTermsLink} {t('OnboardingOffer.And')}{' '}
        {priceListingLink}
      </>
    );

    consentText = t('OnboardingOffer.TermsAndConditionsConsent', {
      termsAndConditionslinkText: formattedLinksText,
    });
  } else {
    const termsAndConditionsLink = (
      <Link size="sm" onClick={openModal}>
        {t('OnboardingOffer.TermsAndConditionslinkText')}
      </Link>
    );

    consentText = t('OnboardingOffer.TermsAndConditionsConsent', {
      termsAndConditionslinkText: termsAndConditionsLink,
    });
  }

  return consentText;
};

export default useLoanConsentText;
